export default "__VITE_ASSET__CkNzHJpd__"